import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import { CommonSelect, CommonToolTip, CstmPagination } from "../../../../components/Common/Common";
import { generatePath, Link, useNavigate } from "react-router-dom";
import { CHATTER_CLIENT_DETAIL } from "config/paths";
import { CHATTER_STATUS_OPTION, CLIENT_REPORT_TYPES } from "config/constants";
import { useFavouriteChatterClientMutation, useGetChatterClientsListQuery } from "store/services/clients/chatter";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import moment from "moment";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { useGetFundingSourceListQuery, useLazyProgramLookupQuery } from "store/services/utility";
import SearchDropdownFilter from "components/shared/SearchDropdownFilter";
import { debounce } from "lodash";
import StepsProgress from "components/shared/FormComponents/StepsProgress";
import ClientsReportMenu from "components/shared/ReportComponents/ClientsReportMenu";
import { useDispatch, useSelector } from "react-redux";
import { chatterClientsFilter, initialFilterState } from "store/slices/filter";
import { usePersistentState } from "hooks/usePersistentState";
import TableLayoutV2 from "components/TableLayoutV2";
import { Star } from "react-feather";
import { useFavouriteSchoolClientMutation } from "store/services/clients/school.client";

const ClientChatter = () => {
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = usePersistentState("chatter:page", 1);
  const filter = useSelector(state => state?.filter?.chatterClientsFilter);
  const [programNameOptions, setProgramNameOptions] = useState([]);
  const [dropdownIndex, setDropdownIndex] = useState(null);

  const { data, isLoading, isError, refetch, isFetching } = useGetChatterClientsListQuery({ page: currentPage, limit: pageSize, ...filter });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  // Funding source filter list
  const { data: fundingSourceList } = useGetFundingSourceListQuery();

  // Program name list
  const [getProgramNameList, { isLoading: programListLoading, isFetching: programListFetching }] = useLazyProgramLookupQuery();
  const [favouriteChatterClient, { isLoading: favouriteChatterLoading }] = useFavouriteChatterClientMutation()

  const getProgramNames = async (search) => {
    try {

      const result = await getProgramNameList(search)
      if (result?.error) return
      setProgramNameOptions(result?.data?.map((item) => ({ value: item.id, label: item?.name })));

    } catch (err) { console.log("error fetching program names", err) };
  };

  // const handleSearch = useCallback(debounce((e) => {
  //   if (e.target.value) getProgramNames(e.target.value);
  //   else setProgramNameOptions([]);

  // }, 500), [500]);

  const handleFavouriteClient = async (id, favorite) => {
    const data = {
      favorite
    }
    try {
      await favouriteChatterClient({ data, id }).unwrap()
      refetch();
    } catch (error) {
      console.log('error making the client favourite: ', error)
    }
  }

  const column = [
    {
      head: <div onClick={() => dispatch(chatterClientsFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "lastname", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
      accessor: "is_favorite",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavouriteClient(item?.client_detail?.id, item?.client_detail?.is_favorite ? 0 : 1) }}>{item?.client_detail?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
      ),
    },
    {
      head: "Last Name",
      accessor: "LastName",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.lastname || "--"}</h6>
      ),
    },
    {
      head: "First Name",
      accessor: "FirstName",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.firstname || "--"}</h6>
      ),
    },
    {
      head: "DOB",
      accessor: "DOB",
      isComponent: true,
      component: (item, ind) => (
        <>{item?.client_detail?.dob ? moment(item?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</>
      ),
    },
    // {
    //   head: "Program Name",
    //   accessor: "ProgramName",
    // },
    {
      head: "Date of Intake",
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <>{moment(item.createdAt).format("DD/MM/YYYY")}</>
      )
    },
    {
      head: "Disciplines",
      accessor: "disciplines",
      component: (item) => {
        const therapists =
          item?.clientPendingCaseload?.clientCaseloadTherapist || [];

        const totalLength = therapists.length;
        const visibleTherapists = therapists.slice(0, 3);
        const remainingCount = totalLength > 3 ? totalLength - 3 : 0;

        let disciplineText = therapists.map((therapist, index) => (
          <li
            key={index}
            style={{
              padding: "7px 7px",
              marginRight: "3px",
              borderRadius: "8px",
              listStyle: "none",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "#fff",
            }}
          >
            <span
              style={{
                width: "6px",
                height: "6px",
                backgroundColor: "#fff",
                borderRadius: "50%",
                display: "inline-block",
              }}
            />
            {therapist?.caseDiscipline?.assign_term}
          </li>
        ));

        return (
          <CommonToolTip
            text={disciplineText}
            component={
              <div>
                {visibleTherapists.map((therapist, index) => (
                  <span
                    key={index}
                    className={`discipline-${therapist?.caseDiscipline?.assign_term}-capsule-bcg`}
                    style={{
                      padding: "7px 10px",
                      marginRight: "3px",
                      borderRadius: "8px",
                    }}
                  >
                    {therapist?.caseDiscipline?.assign_term}
                  </span>
                ))}

                {remainingCount > 0 && <>...+{remainingCount}</>}
              </div>
            }
          />
        );
      } 
    },
    {
      head: "Funding source",
      accessor: "FundingSource",
      isComponent: true,
      component: (item, ind) => (
        <>{item?.client_detail?.client_chatter_detail?.chatter_funding_source?.name || "--"}</>
      ),
    },
    {
      head: "Account Status",
      accessor: "status",
      sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <div style={{ color: item?.status == "active" && '#55A215', fontStyle: ["inactive", 'discharged']?.includes(item?.status) && "italic" }} className="text-capitalize">
          {(item?.status || "--")}
        </div>
      ),
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item, index) => (
        <ClientsReportMenu
          v2={true}
          index={index}
          client={item}
        />
      ),
    },

  ];

  const resetFilter = () => {
    dispatch(chatterClientsFilter(initialFilterState.chatterClientsFilter));
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    dispatch(chatterClientsFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleSearchChange = useCallback(debounce((value) => {

    handleFilterChange("search")(value);

  }, 500), [handleFilterChange, 500]);

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  useEffect(() => {
    getProgramNames();
  }, []);

  const FUNDING_SOURCE_LIST = fundingSourceList?.map((item) => ({
    label: item?.name,
    value: item?.id
  }))

  return (
    <>
      <section className="client position-relative py-4">
        <Container fluid>
          <Row>
            {
              isLoading ? <LoadingIndicator /> : <Col lg="12" className="my-2">
                <Col lg="12">
                  <div className="left classroom-conslutation">
                    <h6 className="m-0 fw-bold main-head themeBlue">Chatter Clients</h6>
                  </div>
                </Col>

                <Row className="reports-v2 my-3 d-flex justify-content-end classroom-conslutation">
                  <Col md='3'>
                  </Col>
                  <Col md='3'>
                    <div className="d-flex w-100 align-items-center gap-3">
                      <label className="discharge-screen-label mb-0">Funding Source </label>
                      <CommonSelect
                        placeholder={"Select"}
                        option={FUNDING_SOURCE_LIST}
                        onChange={(e) => handleFilterChange("funding_source")(e)}
                        value={filter?.funding_source}
                        // onInputChange={(val) => handleSearch(val)}
                        isFilterV2
                        isClearable
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "100%",
                          }),
                        }}
                      />
                    </div>
                  </Col>
                  <Col md='2'>
                    <div className="d-flex w-100 align-items-center gap-3">
                      <label className="discharge-screen-label mb-0">Status</label>
                      <CommonSelect
                        placeholder={"Select"}
                        option={CHATTER_STATUS_OPTION}
                        onChange={(e) => handleFilterChange("status")(e)}
                        value={filter?.status}
                        isFilterV2
                        // isClearable
                        // isLoading={schoolListLoading || schoolListFetching}
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "100%", // ✅ Ensures the whole Select container is full width
                          }),
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="d-flex w-100 align-items-center gap-3">
                      <label className="discharge-screen-label mb-0">Search</label>
                      <input
                        // onChange={handleSearch}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        className={` readonly-box h-auto search-input-filter-v2`}
                        placeholder="Type..."
                        defaultValue={filter?.search}
                      />
                    </div>
                  </Col>
                </Row>

                <div className="table-outer">
                  {isLoading ? (
                    <div style={{ height: "200px" }}>
                      <LoadingIndicator />
                    </div>
                  ) : isError ? (
                    <ErrorComponent />
                  ) : (
                    <>
                      {(isFetching) && <LoadingOverlay />}

                      <TableLayoutV2
                        data={data?.records || []}
                        column={column}
                        url={CHATTER_CLIENT_DETAIL.replace("/:id", "")}
                        handleSort={handleFilterChange("sort")}
                        filter={filter}
                      />
                    </>
                  )}

                  <CstmPagination
                    totalPages={totalPages}
                    activePage={currentPage}
                    className={'paginationV2'}
                    handlePageChange={handlePageChange}
                  />
                </div>
              </Col>
            }
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ClientChatter;
